import { Region } from '@principle-theorem/shared';

export enum Currency {
  AUD = 'AUD',
  NZD = 'NZD',
}

/** Stripe's lower-case currency codes, which Stripe requires on every charge. */
export enum StripeCurrency {
  AUD = 'aud',
  NZD = 'nzd',
}

export const REGION_CURRENCIES: Record<Region, Currency> = {
  [Region.Australia]: Currency.AUD,
  [Region.NewZealand]: Currency.NZD,
};

const stripeCurrencies = new Map<Region, StripeCurrency>([
  [Region.Australia, StripeCurrency.AUD],
  [Region.NewZealand, StripeCurrency.NZD],
]);

export function getCurrencyByRegion(region: Region): Currency {
  return REGION_CURRENCIES[region] ?? Currency.AUD;
}

/**
 * Unlike `getCurrencyByRegion`, an unmapped region throws rather than falling
 * back to AUD, so a patient is never charged in another region's currency.
 */
export function getStripeCurrencyForRegion(region: Region): StripeCurrency {
  const currency = stripeCurrencies.get(region);
  if (!currency) {
    throw new Error(`No Stripe currency for region: ${region}`);
  }
  return currency;
}
